import _isEmpty from 'lodash/isEmpty';
import Parameter, { BoolClause } from './Parameter';
import ParameterKeyValue from './ParameterKeyValue';

export default class Sort extends Parameter {
  private _filterKey: string;
  private _reverse: boolean;
  private _applyDateFilter: boolean;

  constructor(filterKey: string, applyDateFilter: boolean, reverse?: boolean) {
    super();
    this._filterKey = filterKey;
    this._reverse = !!reverse;
    this._applyDateFilter = !!applyDateFilter;
  }

  get parameterKeyValue(): ParameterKeyValue {
    if (_isEmpty(this._filterKey) || !this._applyDateFilter) {
      return new ParameterKeyValue();
    }

    const orderString = this._reverse ? '-' : '';

    return new ParameterKeyValue('_sort', `${orderString}${this._filterKey}`);
  }

  async getFSSClause(): Promise<BoolClause | null> {
    // for FSS, sort is handled separately and not in a query clause.
    return null;
  }
}
